import {
  WorkflowContainerEmptyI,
  WorkflowContainerEmptyActionI,
  WorkflowContainerEmptyRequiredI,
} from "../../../libs/interfaces/lib/workflow-container-empty.interface";
import { StateCreator } from "zustand";
import { removeImageBlob, saveImageBlob } from "../../../libs/helpers";

const MODULE_ID = "container-empty-1";
export const createWorkflowContainerEmptySlice: StateCreator<
  WorkflowContainerEmptyI & WorkflowContainerEmptyActionI,
  [],
  []
> = (set, get) => ({
  firstTakePhoto: "",
  id: null,
  container: "",
  client: null,
  clientId: null,
  producer: null,
  producerShort: null,
  producerId: null,
  farm: null,
  farmShort: null,
  farmId: null,
  magap: "",
  zone: "",
  balerCode: "",
  brand: null,
  brandId: null,
  box: null,
  boxId: null,
  observation: "",

  startProcess: "",
  containerArrival: "",
  containerOpen: "",
  startLoading: "",

  siglasEPhoto: "",
  eir: "",
  eirPhoto: "",
  ciConductor: "",
  ciConductorPhoto: "",
  placa: "",
  placaPhoto: "",
  cabezalPhoto: "",
  etiquetaVerificadoraPuerta: "",
  etiquetaVerificadoraPuertaPhoto: "",
  etiquetasVentoleras: "",
  etiquetasVentolerasPhoto1: "",
  etiquetasVentolerasPhoto2: "",
  etiquetasPanelExterior: "",
  etiquetasPanelExteriorPhoto1: "",
  etiquetasPanelExteriorExp: "",
  etiquetasPanelExteriorExpPhoto: "",
  etiquetasPanelExteriorPhoto2: "",
  etiquetasPanelInterior: "",
  etiquetasPanelInteriorPhoto1: "",
  etiquetasPanelInteriorPhoto2: "",
  etiquetasPanelInteriorPhoto3: "",
  plastico: "",
  plasticoPhoto: "",
  botellaRastreo: "",
  botellaRastreoPhoto: "",
  numRastreoSatelital: "",
  numRastreoSatelitalPhoto: "",
  etiquetaExporPuerta: "",
  etiquetaExporPuertaId: null,
  etiquetaExporPuertaPhoto: "",
  macroEtiquetasVentoleras: "",
  macroEtiquetasVentolerasId: null,
  macroEtiquetasVentolerasPhoto1: "",
  macroEtiquetasVentolerasPhoto2: "",
  macroEtiquetasVentolerasAdicional: "",
  macroEtiquetasVentolerasAdicionalId: null,
  macroEtiquetasVentolerasAdicionalPhoto1: "",
  macroEtiquetasVentolerasAdicionalPhoto2: "",
  paredExternaLadoDerechoPhoto: "",
  paredExternaLadoIzquierdoPhoto: "",
  panelExteriorPhoto: "",
  techoExteriorPhoto: "",
  pisoDerechoExteriorPhoto: "",
  pisoIzquierdoExteriorPhoto: "",
  paredInternaLadoDerechoPhoto: "",
  paredInternaLadoIzquierdoPhoto: "",
  panelInternoPhoto1: "",
  panelInternoPhoto2: "",
  panelInternoPhoto3: "",
  panelInternoPhoto4: "",
  techoInternoPhoto: "",
  pisoInternoPhoto: "",
  parchesPhoto1: "",
  parchesPhoto2: "",
  parchesPhoto3: "",
  parchesExtPhoto1: "",
  parchesExtPhoto2: "",
  parchesExtPhoto3: "",
  calidad: "",
  calidadCi: "",
  gancho: "",
  ganchoCi: "",
  driver: "",
  companyTransport: "",
  numKit: "",
  videoContenedorVacio: "",
  videoPisoExterno: "",
  statusCE: 0,
  processingVideoCV: false,
  processingVideoCE: false,
  setFirstTakePhoto: (firstTakePhoto) => set(() => ({ firstTakePhoto })),
  setContainer: (container) => set(() => ({ container })),
  setClient: (client) => set(() => ({ client })),
  setClientId: (clientId) => set(() => ({ clientId })),
  setProducer: (producer) => set(() => ({ producer })),
  setProducerShort: (producerShort) => set(() => ({ producerShort })),
  setProducerId: (producerId) => set(() => ({ producerId })),
  setFarm: (farm) => set(() => ({ farm })),
  setFarmShort: (farmShort) => set(() => ({ farmShort })),
  setFarmId: (farmId) => set(() => ({ farmId })),
  setZone: (zone) => set(() => ({ zone })),
  setBalerCode: (balerCode) => set(() => ({ balerCode })),
  setBox: (box) => set(() => ({ box })),
  setBoxId: (boxId) => set(() => ({ boxId })),
  setBrand: (brand) => set(() => ({ brand })),
  setBrandId: (brandId) => set(() => ({ brandId })),
  setMagap: (magap) => set(() => ({ magap })),
  setId: (id) => set(() => ({ id })),
  setObservation: (observation) => set(() => ({ observation })),

  setStartProcess: (startProcess) => set(() => ({ startProcess })),
  setContainerArrival: (containerArrival) => set(() => ({ containerArrival })),
  setContainerOpen: (containerOpen) => set(() => ({ containerOpen })),
  setStartLoading: (startLoading) => set(() => ({ startLoading })),

  setNumKit: (numKit) => set(() => ({ numKit })),

  setSiglasEPhoto: async (file) => {
    const ladate = new Date();
    const getImageBack = get().siglasEPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-siglasEPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({
      siglasEPhoto: photoId,
      firstTakePhoto: ladate.toISOString(),
    }));
  },
  setEir: (eir) => set(() => ({ eir })),
  setEirPhoto: async (file) => {
    const getImageBack = get().eirPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-eirPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ eirPhoto: photoId }));
  },
  setCiConductor: (ciConductor) => set(() => ({ ciConductor })),
  setCiConductorPhoto: async (file) => {
    const getImageBack = get().ciConductorPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-ciConductor-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ ciConductorPhoto: photoId }));
  },
  setCabezalPhoto: async (file) => {
    const getImageBack = get().cabezalPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-cabezalPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ cabezalPhoto: photoId }));
  },
  setPlaca: (placa) => set(() => ({ placa })),
  setPlacaPhoto: async (file) => {
    const getImageBack = get().placaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-placaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ placaPhoto: photoId }));
  },
  setEtiquetaVerificadoraPuerta: (etiquetaVerificadoraPuerta) =>
    set(() => ({ etiquetaVerificadoraPuerta })),
  setEtiquetaVerificadoraPuertaPhoto: async (file) => {
    const getImageBack = get().etiquetaVerificadoraPuertaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetaVerificadoraPuertaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ etiquetaVerificadoraPuertaPhoto: photoId }));
  },
  setEtiquetasVentoleras: (etiquetasVentoleras) =>
    set(() => ({ etiquetasVentoleras })),
  setEtiquetasVentolerasPhoto1: async (file) => {
    const getImageBack = get().etiquetasVentolerasPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasVentolerasPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasVentolerasPhoto1: photoId }));
  },
  setEtiquetasVentolerasPhoto2: async (file) => {
    const getImageBack = get().etiquetasVentolerasPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasVentolerasPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ etiquetasVentolerasPhoto2: photoId }));
  },
  setEtiquetasPanelExterior: (etiquetasPanelExterior) =>
    set(() => ({ etiquetasPanelExterior })),
  setEtiquetasPanelExteriorPhoto1: async (file) => {
    const getImageBack = get().etiquetasPanelExteriorPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelExteriorPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasPanelExteriorPhoto1: photoId }));
  },
  setEtiquetasPanelExteriorPhoto2: async (file) => {
    const getImageBack = get().etiquetasPanelExteriorPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelExteriorPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasPanelExteriorPhoto2: photoId }));
  },
  setEtiquetasPanelExteriorExp: (etiquetasPanelExteriorExp) =>
    set(() => ({ etiquetasPanelExteriorExp })),
  setEtiquetasPanelExteriorExpPhoto: async (file) => {
    const getImageBack = get().etiquetasPanelExteriorExpPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelExteriorExpPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasPanelExteriorExpPhoto: photoId }));
  },
  setEtiquetasPanelInterior: (etiquetasPanelInterior) =>
    set(() => ({ etiquetasPanelInterior })),
  setEtiquetasPanelInteriorPhoto1: async (file) => {
    const getImageBack = get().etiquetasPanelInteriorPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelInteriorPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ etiquetasPanelInteriorPhoto1: photoId }));
  },
  setEtiquetasPanelInteriorPhoto2: async (file) => {
    const getImageBack = get().etiquetasPanelInteriorPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelInteriorPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasPanelInteriorPhoto2: photoId }));
  },
  setEtiquetasPanelInteriorPhoto3: async (file) => {
    const getImageBack = get().etiquetasPanelInteriorPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetasPanelInteriorPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ etiquetasPanelInteriorPhoto3: photoId }));
  },
  setPlastico: (plastico) => set(() => ({ plastico })),
  setPlasticoPhoto: async (file) => {
    const getImageBack = get().plasticoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-plasticoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);

    set(() => ({ plasticoPhoto: photoId }));
  },
  setBotellaRastreo: (botellaRastreo) => set(() => ({ botellaRastreo })),
  setBotellaRastreoPhoto: async (file) => {
    const getImageBack = get().botellaRastreoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-botellaRastreoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ botellaRastreoPhoto: photoId }));
  },
  setNumRastreoSatelital: (numRastreoSatelital) =>
    set(() => ({ numRastreoSatelital })),
  setNumRastreoSatelitalPhoto: async (file) => {
    const getImageBack = get().numRastreoSatelitalPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-numRastreoSatelitalPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ numRastreoSatelitalPhoto: photoId }));
  },
  setEtiquetaExporPuerta: (etiquetaExporPuerta) =>
    set(() => ({ etiquetaExporPuerta })),
  setEtiquetaExporPuertaId: (etiquetaExporPuertaId) =>
    set(() => ({ etiquetaExporPuertaId })),
  setEtiquetaExporPuertaPhoto: async (file) => {
    const getImageBack = get().etiquetaExporPuertaPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-etiquetaExporPuertaPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ etiquetaExporPuertaPhoto: photoId }));
  },
  setMacroEtiquetasVentoleras: (macroEtiquetasVentoleras) =>
    set(() => ({ macroEtiquetasVentoleras })),
  setMacroEtiquetasVentolerasId: (macroEtiquetasVentolerasId) =>
    set(() => ({ macroEtiquetasVentolerasId })),
  setMacroEtiquetasVentolerasPhoto1: async (file) => {
    const getImageBack = get().macroEtiquetasVentolerasPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-macroEtiquetasVentolerasPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ macroEtiquetasVentolerasPhoto1: photoId }));
  },
  setMacroEtiquetasVentolerasPhoto2: async (file) => {
    const getImageBack = get().macroEtiquetasVentolerasPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-macroEtiquetasVentolerasPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ macroEtiquetasVentolerasPhoto2: photoId }));
  },
  setMacroEtiquetasVentolerasAdicional: (macroEtiquetasVentolerasAdicional) =>
    set(() => ({ macroEtiquetasVentolerasAdicional })),
  setMacroEtiquetasVentolerasAdicionalId: (
    macroEtiquetasVentolerasAdicionalId
  ) => set(() => ({ macroEtiquetasVentolerasAdicionalId })),
  setMacroEtiquetasVentolerasAdicionalPhoto1: async (file) => {
    const getImageBack = get().macroEtiquetasVentolerasAdicionalPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-macroEtiquetasVentolerasAdicionalPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ macroEtiquetasVentolerasAdicionalPhoto1: photoId }));
  },
  setMacroEtiquetasVentolerasAdicionalPhoto2: async (file) => {
    const getImageBack = get().macroEtiquetasVentolerasAdicionalPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-macroEtiquetasVentolerasAdicionalPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ macroEtiquetasVentolerasAdicionalPhoto2: photoId }));
  },
  setParedExternaLadoDerechoPhoto: async (file) => {
    const getImageBack = get().paredExternaLadoDerechoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-paredExternaLadoDerechoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ paredExternaLadoDerechoPhoto: photoId }));
  },
  setParedExternaLadoIzquierdoPhoto: async (file) => {
    const getImageBack = get().paredExternaLadoIzquierdoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-paredExternaLadoIzquierdoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ paredExternaLadoIzquierdoPhoto: photoId }));
  },
  setPanelExteriorPhoto: async (file) => {
    const getImageBack = get().panelExteriorPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelExteriorPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ panelExteriorPhoto: photoId }));
  },
  setTechoExteriorPhoto: async (file) => {
    const getImageBack = get().techoExteriorPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-techoExteriorPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ techoExteriorPhoto: photoId }));
  },
  setPisoDerechoExteriorPhoto: async (file) => {
    const getImageBack = get().pisoDerechoExteriorPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-pisoDerechoExteriorPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ pisoDerechoExteriorPhoto: photoId }));
  },
  setPisoIzquierdoExteriorPhoto: async (file) => {
    const getImageBack = get().pisoIzquierdoExteriorPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-pisoIzquierdoExteriorPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ pisoIzquierdoExteriorPhoto: photoId }));
  },
  setParedInternaLadoDerechoPhoto: async (file) => {
    const getImageBack = get().paredInternaLadoDerechoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-paredInternaLadoDerechoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ paredInternaLadoDerechoPhoto: photoId }));
  },
  setParedInternaLadoIzquierdoPhoto: async (file) => {
    const getImageBack = get().paredInternaLadoIzquierdoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-paredInternaLadoIzquierdoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ paredInternaLadoIzquierdoPhoto: photoId }));
  },
  setPanelInternoPhoto1: async (file) => {
    const getImageBack = get().panelInternoPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelInternoPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ panelInternoPhoto1: photoId }));
  },
  setPanelInternoPhoto2: async (file) => {
    const getImageBack = get().panelInternoPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelInternoPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ panelInternoPhoto2: photoId }));
  },
  setPanelInternoPhoto3: async (file) => {
    const getImageBack = get().panelInternoPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelInternoPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ panelInternoPhoto3: photoId }));
  },
  setPanelInternoPhoto4: async (file) => {
    const getImageBack = get().panelInternoPhoto4;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-panelInternoPhoto4-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ panelInternoPhoto4: photoId }));
  },
  setTechoInternoPhoto: async (file) => {
    const getImageBack = get().techoInternoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-techoInternoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ techoInternoPhoto: photoId }));
  },
  setPisoInternoPhoto: async (file) => {
    const getImageBack = get().pisoInternoPhoto;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-pisoInternoPhoto-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ pisoInternoPhoto: photoId }));
  },
  setParchesPhoto1: async (file) => {
    const getImageBack = get().parchesPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesPhoto1: photoId }));
  },
  setParchesPhoto2: async (file) => {
    const getImageBack = get().parchesPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesPhoto2: photoId }));
  },
  setParchesPhoto3: async (file) => {
    const getImageBack = get().parchesPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesPhoto3: photoId }));
  },
  setParchesExtPhoto1: async (file) => {
    const getImageBack = get().parchesExtPhoto1;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesExtPhoto1-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesExtPhoto1: photoId }));
  },
  setParchesExtPhoto2: async (file) => {
    const getImageBack = get().parchesExtPhoto2;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesExtPhoto2-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesExtPhoto2: photoId }));
  },
  setParchesExtPhoto3: async (file) => {
    const getImageBack = get().parchesExtPhoto3;
    if (getImageBack) await removeImageBlob(getImageBack);

    const photoId = `${MODULE_ID}-parchesExtPhoto3-${crypto.randomUUID()}`;

    const blob = await (await fetch(file)).blob();

    await saveImageBlob(photoId, blob as any);
    set(() => ({ parchesExtPhoto3: photoId }));
  },
  setCalidad: (calidad) => set(() => ({ calidad })),
  setCalidadCi: (calidadCi) => set(() => ({ calidadCi })),
  setGancho: (gancho) => set(() => ({ gancho })),
  setGanchoCi: (ganchoCi) => set(() => ({ ganchoCi })),
  setDriver: (driver) => set(() => ({ driver })),

  setCompanyTransport(companyTransport) {
    set(() => ({ companyTransport }));
  },

  setDataContainerEmpty: (ladata) => set(ladata),
  setVideoContenedorVacio: async (file) => {
    if (!file) {
      set(() => ({ videoContenedorVacio: "" }));
      return;
    }
    set(() => ({ videoContenedorVacio: file }));
  },
  setVideoPisoExterno: async (videoPisoExterno) => {
    if (!videoPisoExterno) {
      set(() => ({
        videoPisoExterno: "",
      }));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(videoPisoExterno as unknown as Blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      set(() => ({
        videoPisoExterno: base64data as string,
        processingVideoCE: false,
      }));
    };
  },
  setProcessingVideoCV: (processingVideoCV) =>
    set(() => ({ processingVideoCV })),
  setProcessingVideoCE: (processingVideoCE) =>
    set(() => ({ processingVideoCE })),
  applyRehydratedState: (rehydratedState) =>
    set((current) => ({
      ...current,
      ...rehydratedState,
    })),
  resetClient: () => {
    set(() => ({
      producerId: null,
      producer: null,
      producerShort: null,
      farmId: null,
      farm: null,
      farmShort: null,
      brandId: null,
      brand: null,
      boxId: null,
      box: "",
      balerCode: "",
      zone: "",
    }));
  },
  resetProducer: () => {
    set(() => ({
      farmId: null,
      farm: null,
      farmShort: null,
      balerCode: "",
      zone: "",
    }));
  },
  resetFarm: () => {
    set(() => ({
      farmId: null,
      farm: null,
      farmShort: null,
      balerCode: "",
      zone: "",
    }));
  },
  getDataContainerEmpty: () => {
    const obj = {
      clientId: get().clientId,
      container: get().container,
      producerId: get().producerId,
      producer: get().producer,
      farmId: get().farmId,
      farm: get().farm,
      brandId: get().brandId,
      boxId: get().boxId,
      balerCode: get().balerCode,
      magap: get().magap,
      numKit: get().numKit,
      observation: get().observation,
      siglasEPhoto: get().siglasEPhoto,
      eir: get().eir,
      eirPhoto: get().eirPhoto,
      ciConductor: get().ciConductor,
      ciConductorPhoto: get().ciConductorPhoto,
      cabezalPhoto: get().cabezalPhoto,
      placa: get().placa,
      placaPhoto: get().placaPhoto,
      etiquetaVerificadoraPuerta: get().etiquetaVerificadoraPuerta,
      etiquetaVerificadoraPuertaPhoto: get().etiquetaVerificadoraPuertaPhoto,
      etiquetasVentoleras: get().etiquetasVentoleras,
      etiquetasVentolerasPhoto1: get().etiquetasVentolerasPhoto1,
      etiquetasVentolerasPhoto2: get().etiquetasVentolerasPhoto2,
      etiquetasPanelExterior: get().etiquetasPanelExterior,
      etiquetasPanelExteriorPhoto1: get().etiquetasPanelExteriorPhoto1,
      etiquetasPanelExteriorPhoto2: get().etiquetasPanelExteriorPhoto2,
      etiquetasPanelInterior: get().etiquetasPanelInterior,
      etiquetasPanelInteriorPhoto1: get().etiquetasPanelInteriorPhoto1,
      etiquetasPanelInteriorPhoto2: get().etiquetasPanelInteriorPhoto2,
      etiquetasPanelInteriorPhoto3: get().etiquetasPanelInteriorPhoto3,
      etiquetasPanelExteriorExp: get().etiquetasPanelExteriorExp,
      etiquetasPanelExteriorExpPhoto: get().etiquetasPanelExteriorExpPhoto,
      plastico: get().plastico,
      plasticoPhoto: get().plasticoPhoto,
      botellaRastreo: get().botellaRastreo,
      botellaRastreoPhoto: get().botellaRastreoPhoto,
      numRastreoSatelital: get().numRastreoSatelital,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      etiquetaExporPuerta: get().etiquetaExporPuerta,
      // etiquetaExporPuertaId: get().etiquetaExporPuertaId,
      etiquetaExporPuertaPhoto: get().etiquetaExporPuertaPhoto,
      macroEtiquetasVentoleras: get().macroEtiquetasVentoleras,
      // macroEtiquetasVentolerasId: get().macroEtiquetasVentolerasId,
      macroEtiquetasVentolerasPhoto1: get().macroEtiquetasVentolerasPhoto1,
      macroEtiquetasVentolerasPhoto2: get().macroEtiquetasVentolerasPhoto2,
      macroEtiquetasVentolerasAdicional:
        get().macroEtiquetasVentolerasAdicional,
      macroEtiquetasVentolerasAdicionalId:
        get().macroEtiquetasVentolerasAdicionalId,
      macroEtiquetasVentolerasAdicionalPhoto1:
        get().macroEtiquetasVentolerasAdicionalPhoto1,
      macroEtiquetasVentolerasAdicionalPhoto2:
        get().macroEtiquetasVentolerasAdicionalPhoto2,
      paredExternaLadoDerechoPhoto: get().paredExternaLadoDerechoPhoto,
      paredExternaLadoIzquierdoPhoto: get().paredExternaLadoIzquierdoPhoto,
      panelExteriorPhoto: get().panelExteriorPhoto,
      techoExteriorPhoto: get().techoExteriorPhoto,
      pisoDerechoExteriorPhoto: get().pisoDerechoExteriorPhoto,
      pisoIzquierdoExteriorPhoto: get().pisoIzquierdoExteriorPhoto,
      paredInternaLadoDerechoPhoto: get().paredInternaLadoDerechoPhoto,
      paredInternaLadoIzquierdoPhoto: get().paredInternaLadoIzquierdoPhoto,
      panelInternoPhoto1: get().panelInternoPhoto1,
      panelInternoPhoto2: get().panelInternoPhoto2,
      panelInternoPhoto3: get().panelInternoPhoto3,
      panelInternoPhoto4: get().panelInternoPhoto4,
      techoInternoPhoto: get().techoInternoPhoto,
      pisoInternoPhoto: get().pisoInternoPhoto,
      parchesPhoto1: get().parchesPhoto1,
      parchesPhoto2: get().parchesPhoto2,
      parchesPhoto3: get().parchesPhoto3,
      parchesExtPhoto1: get().parchesExtPhoto1,
      parchesExtPhoto2: get().parchesExtPhoto2,
      parchesExtPhoto3: get().parchesExtPhoto3,
      videoContenedorVacio: get().videoContenedorVacio,
      videoPisoExterno: get().videoPisoExterno,
      startProcess: get().startProcess,
      containerArrival: get().containerArrival,
      containerOpen: get().containerOpen,
      startLoading: get().startLoading,
      calidad: get().calidad,
      calidadCi: get().calidadCi,
      gancho: get().gancho,
      ganchoCi: get().ganchoCi,
      driver: get().driver,
      companyTransport: get().companyTransport,
    } as WorkflowContainerEmptyRequiredI;

    return obj;
  },

  getStatusCE: () => console.log("a"),
  // set((state) => {
  //   const obj = get().getDataContainerEmpty();
  //   const values = Object.values(obj);
  //   let num = 0;
  //   for (const x of values) {
  //     if (x) num++;
  //   }
  //   const percentage = (num * 100) / 71;

  //   return {
  //     ...state,
  //     statusCE: percentage,
  //   };
  // }),

  getOnlyPhotos: () => {
    const obj = {
      siglasEPhoto: get().siglasEPhoto,
      eirPhoto: get().eirPhoto,
      ciConductorPhoto: get().ciConductorPhoto,
      cabezalPhoto: get().cabezalPhoto,
      placaPhoto: get().placaPhoto,
      etiquetaVerificadoraPuertaPhoto: get().etiquetaVerificadoraPuertaPhoto,
      etiquetasVentolerasPhoto1: get().etiquetasVentolerasPhoto1,
      etiquetasVentolerasPhoto2: get().etiquetasVentolerasPhoto2,
      etiquetasPanelExteriorPhoto1: get().etiquetasPanelExteriorPhoto1,
      etiquetasPanelExteriorPhoto2: get().etiquetasPanelExteriorPhoto2,
      etiquetasPanelInteriorPhoto1: get().etiquetasPanelInteriorPhoto1,
      etiquetasPanelInteriorPhoto2: get().etiquetasPanelInteriorPhoto2,
      etiquetasPanelInteriorPhoto3: get().etiquetasPanelInteriorPhoto3,
      etiquetasPanelExteriorExpPhoto: get().etiquetasPanelExteriorExpPhoto,
      plasticoPhoto: get().plasticoPhoto,
      botellaRastreoPhoto: get().botellaRastreoPhoto,
      numRastreoSatelitalPhoto: get().numRastreoSatelitalPhoto,
      etiquetaExporPuertaPhoto: get().etiquetaExporPuertaPhoto,
      macroEtiquetasVentolerasPhoto1: get().macroEtiquetasVentolerasPhoto1,
      macroEtiquetasVentolerasPhoto2: get().macroEtiquetasVentolerasPhoto2,
      macroEtiquetasVentolerasAdicionalPhoto1:
        get().macroEtiquetasVentolerasAdicionalPhoto1,
      macroEtiquetasVentolerasAdicionalPhoto2:
        get().macroEtiquetasVentolerasAdicionalPhoto2,
      paredExternaLadoDerechoPhoto: get().paredExternaLadoDerechoPhoto,
      paredExternaLadoIzquierdoPhoto: get().paredExternaLadoIzquierdoPhoto,
      panelExteriorPhoto: get().panelExteriorPhoto,
      techoExteriorPhoto: get().techoExteriorPhoto,
      pisoDerechoExteriorPhoto: get().pisoDerechoExteriorPhoto,
      pisoIzquierdoExteriorPhoto: get().pisoIzquierdoExteriorPhoto,
      paredInternaLadoDerechoPhoto: get().paredInternaLadoDerechoPhoto,
      paredInternaLadoIzquierdoPhoto: get().paredInternaLadoIzquierdoPhoto,
      panelInternoPhoto1: get().panelInternoPhoto1,
      panelInternoPhoto2: get().panelInternoPhoto2,
      panelInternoPhoto3: get().panelInternoPhoto3,
      panelInternoPhoto4: get().panelInternoPhoto4,
      techoInternoPhoto: get().techoInternoPhoto,
      pisoInternoPhoto: get().pisoInternoPhoto,
      parchesPhoto1: get().parchesPhoto1,
      parchesPhoto2: get().parchesPhoto2,
      parchesPhoto3: get().parchesPhoto3,
      parchesExtPhoto1: get().parchesExtPhoto1,
      parchesExtPhoto2: get().parchesExtPhoto2,
      parchesExtPhoto3: get().parchesExtPhoto3,
      videoContenedorVacio: get().videoContenedorVacio,
    };
    return obj;
  },
  onClear: async () => {
    const state = get();
    const keys = [
      state.siglasEPhoto,
      state.eirPhoto,
      state.ciConductorPhoto,
      state.cabezalPhoto,
      state.placaPhoto,
      state.etiquetaVerificadoraPuertaPhoto,
      state.etiquetasVentolerasPhoto1,
      state.etiquetasVentolerasPhoto2,
      state.etiquetasPanelExteriorPhoto1,
      state.etiquetasPanelExteriorPhoto2,
      state.etiquetasPanelInteriorPhoto1,
      state.etiquetasPanelInteriorPhoto2,
      state.etiquetasPanelInteriorPhoto3,
      state.etiquetasPanelExteriorExpPhoto,
      state.plasticoPhoto,
      state.botellaRastreoPhoto,
      state.numRastreoSatelitalPhoto,
      state.etiquetaExporPuertaPhoto,
      state.macroEtiquetasVentolerasPhoto1,
      state.macroEtiquetasVentolerasPhoto2,
      state.macroEtiquetasVentolerasAdicionalPhoto1,
      state.macroEtiquetasVentolerasAdicionalPhoto2,
      state.paredExternaLadoDerechoPhoto,
      state.paredExternaLadoIzquierdoPhoto,
      state.panelExteriorPhoto,
      state.techoExteriorPhoto,
      state.pisoDerechoExteriorPhoto,
      state.pisoIzquierdoExteriorPhoto,
      state.paredInternaLadoDerechoPhoto,
      state.paredInternaLadoIzquierdoPhoto,
      state.panelInternoPhoto1,
      state.panelInternoPhoto2,
      state.panelInternoPhoto3,
      state.panelInternoPhoto4,
      state.techoInternoPhoto,
      state.pisoInternoPhoto,
      state.parchesPhoto1,
      state.parchesPhoto2,
      state.parchesPhoto3,
      state.parchesExtPhoto1,
      state.parchesExtPhoto2,
      state.parchesExtPhoto3,
      state.videoContenedorVacio,
    ];

    for (const key of keys) {
      // if (key &&
      //   !key.startsWith("http://") ||
      //   !key.startsWith("https://") ||
      //   !key.startsWith("data:")
      // ) {
      //   await removeImageBlob(key);
      // }
      if (
        key &&
        !key.startsWith("http://") &&
        !key.startsWith("https://") &&
        !key.startsWith("data:")
      ) {
        await removeImageBlob(key);
      }
    }

    set(() => ({
      step: "Formulario",
      firstTakePhoto: "",
      id: null,
      container: "",
      producer: null,
      producerShort: null,
      producerId: null,
      farm: null,
      farmShort: null,
      farmId: null,
      magap: "",
      zone: "",
      balerCode: "",
      brand: null,
      brandId: null,
      box: null,
      boxId: null,
      observation: "",

      startProcess: "",
      containerArrival: "",
      containerOpen: "",
      startLoading: "",

      siglasEPhoto: "",
      numKit: "",
      eir: "",
      eirPhoto: "",
      ciConductor: "",
      ciConductorPhoto: "",
      placa: "",
      placaPhoto: "",
      cabezalPhoto: "",
      etiquetaVerificadoraPuerta: "",
      etiquetaVerificadoraPuertaPhoto: "",
      etiquetasVentoleras: "",
      etiquetasVentolerasPhoto1: "",
      etiquetasVentolerasPhoto2: "",
      etiquetasPanelExterior: "",
      etiquetasPanelExteriorPhoto1: "",
      etiquetasPanelExteriorPhoto2: "",
      etiquetasPanelInterior: "",
      etiquetasPanelInteriorPhoto1: "",
      etiquetasPanelInteriorPhoto2: "",
      etiquetasPanelInteriorPhoto3: "",
      etiquetasPanelExteriorExp: "",
      etiquetasPanelExteriorExpPhoto: "",
      plastico: "",
      plasticoPhoto: "",
      botellaRastreo: "",
      botellaRastreoPhoto: "",
      numRastreoSatelital: "",
      numRastreoSatelitalPhoto: "",
      etiquetaExporPuerta: "",
      etiquetaExporPuertaId: null,
      etiquetaExporPuertaPhoto: "",
      macroEtiquetasVentoleras: "",
      macroEtiquetasVentolerasId: null,
      macroEtiquetasVentolerasPhoto1: "",
      macroEtiquetasVentolerasPhoto2: "",
      macroEtiquetasVentolerasAdicional: "",
      macroEtiquetasVentolerasAdicionalId: null,
      macroEtiquetasVentolerasAdicionalPhoto1: "",
      macroEtiquetasVentolerasAdicionalPhoto2: "",
      paredExternaLadoDerechoPhoto: "",
      paredExternaLadoIzquierdoPhoto: "",
      panelExteriorPhoto: "",
      techoExteriorPhoto: "",
      pisoDerechoExteriorPhoto: "",
      pisoIzquierdoExteriorPhoto: "",
      paredInternaLadoDerechoPhoto: "",
      paredInternaLadoIzquierdoPhoto: "",
      techoInternoPhoto: "",
      pisoInternoPhoto: "",
      parchesPhoto1: "",
      parchesPhoto2: "",
      parchesPhoto3: "",
      videoContenedorVacio: "",
      videoPisoExterno: "",
      statusCE: 0,
      processingVideoCV: false,
      processingVideoCE: false,
      panelInternoPhoto1: "",
      panelInternoPhoto2: "",
      panelInternoPhoto3: "",
      panelInternoPhoto4: "",
      parchesExtPhoto1: "",
      parchesExtPhoto2: "",
      parchesExtPhoto3: "",
      calidad: "",
      calidadCi: "",
      gancho: "",
      ganchoCi: "",
      driver: "",
      plate: "",
      companyTransport: "",
    }));
  },
});
